import { createFileRoute } from "@tanstack/react-router";

import { MarkUpdatesSeenOnVisit } from "#/components/MarkUpdatesSeenOnVisit";
import { PageDescription } from "#/components/PageDescription";
import { PageEyeBrow } from "#/components/PageEyeBrow";
import { PageHeader } from "#/components/PageHeader";
import { PageIntro } from "#/components/PageIntro";
import { PageShell } from "#/components/PageShell";
import { DOCUMENT_TITLES, documentHead } from "#/lib/documentTitle";

import { ChangelogTimeline } from "./-updates.timeline";

export const Route = createFileRoute("/updates")({
  head: () => documentHead(DOCUMENT_TITLES.updates),
  component: UpdatesPage,
});

function UpdatesPage() {
  return (
    <PageShell>
      <MarkUpdatesSeenOnVisit />
      <PageIntro align="start">
        <PageEyeBrow>Latest news from the front</PageEyeBrow>
        <PageHeader>Updates</PageHeader>
        <PageDescription>
          Keep track of the latest features, balance changes, and bug fixes.
        </PageDescription>
      </PageIntro>
      <div className="mt-2">
        <ChangelogTimeline />
      </div>
    </PageShell>
  );
}
